import React from 'react';

const SummaryMetrics = ({ metrics, darkMode }) => {
  if (!metrics) return null;

  const metricCards = [
    { label: 'Logins Today', value: metrics.totalLoginsToday || 0 },
    { label: 'Logins This Week', value: metrics.totalLoginsWeek || 0 },
    { label: 'Logins This Month', value: metrics.totalLoginsMonth || 0 },
    { label: 'Unique Users Today', value: metrics.uniqueUsersToday || 0 },
    { label: 'Failed Attempts (24h)', value: metrics.failedAttempts24h || 0 },
    { label: 'Failed Attempts (Week)', value: metrics.failedAttemptsWeek || 0 },
    { label: 'Avg Session Duration', value: metrics.avgSessionDuration ? `${Math.floor(metrics.avgSessionDuration / 60)}m` : '0m' },
    { label: 'Permission Changes', value: metrics.permissionChanges || 0 }
  ];

  return (
    <div className={`summary-metrics ${darkMode ? 'dark-mode' : ''}`}>
      {metricCards.map((card, index) => (
        <div key={index} className="metric-card">
          <div className="metric-label">{card.label}</div>
          <div className="metric-value">{card.value}</div>
        </div>
      ))}
    </div>
  );
};

export default SummaryMetrics;

